import config from "../../config";
import {
  ActionsStatus,
  AuditStatus,
  EventStatus,
  ProjectStatus,
} from "../../types/status";

export const getStatusInfos = (
  type: "events" | "actions" | "audits" | "projects",
  status: EventStatus | ActionsStatus | AuditStatus | ProjectStatus,
) => {
  const _status =
    config[
      type === "actions"
        ? "actionStatus"
        : type === "audits"
          ? "auditStatus"
          : type === "projects"
            ? "projectStatus"
            : "eventStatus"
    ];

  // TODO Max TS
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const info = _status[status];

  return {
    label: info?.label || "Not found",
    color: info?.color || "grey",
  };
};
